import * as React from "react";

import { PageGenericError } from "@mnemonic/mui";

import { DEFAULT_ERROR_KEY, ErrorBoundary } from "./ErrorBoundary";

export interface ITopLevelErrorBoundaryProps {
  children: React.ReactNode;
}

const TopLevelErrorBoundary = ({ children, ...rest }: ITopLevelErrorBoundaryProps) => (
  <ErrorBoundary
    {...rest}
    handlers={{
      [DEFAULT_ERROR_KEY]: { Component: PageGenericError },
    }}
  >
    {children}
  </ErrorBoundary>
);

export default TopLevelErrorBoundary;
